var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('error-group',{attrs:{"validator":_vm.validations,"name":"field"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var attrs = ref.attrs;
return _c('v-autocomplete',_vm._b({attrs:{"label":_vm.field.label,"value":_vm.value,"disabled":_vm.readonly,"items":_vm.field.options,"color":"#005c7b"},on:{"change":_vm.onChange}},'v-autocomplete',attrs,false))}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }